import React from "react";
import { Outlet } from "react-router-dom";
import { makeStyles, tokens, Card } from "@fluentui/react-components";

const useStyles = makeStyles({
  content: {
    padding: `0 ${tokens.spacingHorizontalL}`,
    minHeight: "100%",
    width: "100%",
    margin: "0 auto",
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  card: {
    minHeight: "100%",
    width: "100%",
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
  },
});

const PageContent: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.content}>
      <Card className={styles.card}>
        <Outlet />
      </Card>
    </div>
  );
};

export default PageContent;
